import React, { Component } from "react";
import TextInput from "../UI/TextInput";
import { instaQuoteApi } from "../../services/instaQuoteApi";
import { agentAppointmentDetailApi } from "../../services/agentAppointmentDetailApi";
import { leadSubmissionApi } from "../../services/leadSubmissionApi";

export class Contact extends Component {
    continue = (e) => {
        e.preventDefault();
        //console.log(e);

        if (this.props.values.initStep3From) {
            this.props.handleValidationFields(3);
        }

        if (this.props.values.step3FormValid) {
            let diff = this.props.values.movingDate - new Date();
            let isMoveWithin7Days = diff <= 604800000;  //Diff in 7 Days in millisecond

            this.props.nextStep();

            //IF Local Move then no Need to Call InstaQuote API.
            if (this.props.values.isLocalMove) {
                if (!isMoveWithin7Days) { //No need to show appointment booking
                    this.getAppointmentDataFromApi();
                }
                else { //If Move within 7 Days then post the lead.
                    this.postLeadThruApi();
                }
                //return;
            }
            else {
                //Get InstaQuote From API
                const instaQuoteService = new instaQuoteApi(this.props, isMoveWithin7Days, this.props.handleInstaQuotePriceRance);
                instaQuoteService.GetInstaquoteData().then(
                    (instaQuoteSuccess) => {
                        if (instaQuoteSuccess) {
                            if (!isMoveWithin7Days) { //No need to show appointment booking
                                this.getAppointmentDataFromApi();
                            }
                            else { //If Move within 7 Days then post the lead.
                                this.postLeadThruApi();
                            }
                        }
                        else {
                            console.log("Instaquote Api Data Get Failed !");
                        }
                    }
                );
            }

            try {
                if (typeof (ga) === "function") {
                    var fields = {
                        hitType: "event",
                        event_category: "onlinebooking",
                        eventAction: "completed Contact Info",
                        value: "4",
                    };

                    window.gtag('event', fields.eventAction, fields);
                }
            } catch (err) {
                console.log("Error Logging Google Analytics Event for Step 4 - Online booking");
            }
        }
    };

    previous = (e) => {
        e.preventDefault();
        this.props.prevStep();
    };

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getAppointmentDataFromApi() {
        const agentAppointmentdetailapi = new agentAppointmentDetailApi(this.props, this.props.handleAgentAppointmentDetailFromApi, this.props.handleLeadSubmission);

        //Get Agent Details
        agentAppointmentdetailapi.GetAgentAppointmentDetail().then(
            (agentAppDetailSuccess) => {
                if (agentAppDetailSuccess) {
                    console.log("this Worked !");
                }
            }
        );
    }

    postLeadThruApi() {
        //Submit Lead    
        const leadSubmissionService = new leadSubmissionApi(this.props, this.props.handleLeadSubmission);

        leadSubmissionService.submitLead(false).then((leadSuccess) => {
            if (leadSuccess) {
                console.log("Lead Success");
            }
            else {
                console.log("Lead Failed");
            }
        });
    }

    render() {
        const { values, handleChange } = this.props;

        return (
            <div className="ob-bg">
                <div className="ob-wrapper">
                    <h2 className="ob-h2">{document.getElementById("Step3Title").value}</h2>
                    <div className="ob-box">
                        <h3>Contact Information</h3>
                        <TextInput
                            label="Full Name"
                            id="contactName"
                            placeholder="Enter full name"
                            value={values.contactName}
                            required
                            onChange={handleChange("contactName")}
                            isValid={(values.contactNameValid)}
                            validationMessage={values.formErrors.contactNameErrMsg}
                            className="ob-input"
                        />
                        <TextInput
                            label="Email"
                            id="contactEmail"
                            placeholder="Enter email"
                            value={values.contactEmail}
                            required
                            onChange={handleChange("contactEmail")}
                            isValid={(values.contactEmailValid)}
                            validationMessage={values.formErrors.contactEmailErrMsg}
                        />
                        <TextInput
                            label="Phone"
                            id="contactPhone"
                            placeholder="Enter phone number"
                            value={values.contactPhone}
                            required
                            onChange={handleChange("contactPhone")}
                            isValid={(values.contactPhoneValid)}
                            validationMessage={values.formErrors.contactPhoneErrMsg}
                            // handlePhoneFormat={handlePhoneFormat}
                        />
                    </div>
                    <div className="ob-contact__footer">
                        <p className="ob-disclaimer">
                        {document.getElementById("Step3Consent").value}
                        </p>

                        <div className="ob-btn__container ob-btn--contact">
                            <button className="ob-btn ob-btn--wide" onClick={this.continue}>
                                {document.getElementById("Step3NextButtonText").value}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contact;
